import React, { useCallback } from 'react';
import { FormControl, useFormField, FieldProps } from '@core/utils/form';
import { Label, FormGroup } from 'reactstrap';
import FormHelperText from '@material-ui/core/FormHelperText';
import { toMoment, TimeInput } from '@core/utils/time';

import { DayPickerRangeController, DayPickerRangeControllerShape } from 'react-dates';
import moment from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { R } from '@core/utils/r';
import { Calendar, CalendarProps, theme } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
export interface FormDateInlineProps extends FieldProps<FormControl<number>> {
  options?: Partial<DayPickerRangeControllerShape>;
  minDate?: TimeInput;
  maxDate?: TimeInput;
  onChange?(date: number): void;
  numberOfMonths?: number;
  useUtc?: boolean;
}

export function FormDateInline(props: FormDateInlineProps) {
  const { formControl, fieldState, fieldConfig } = useFormField(props);
  const { useUtc = true } = props;
  dayjs.extend(utc);
  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldValue = fieldState.value ? toMoment(fieldState.value, { utc: useUtc }) : null;
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const fieldDisabled = fieldConfig.disabled || false;
  const validRange: [dayjs.Dayjs, dayjs.Dayjs] = [
    dayjs(moment('1800-01-01').format('YYYY-MM-DD')),
    dayjs(moment().add(5, 'years').format('YYYY-MM-DD')),
  ];

  const handleChange = useCallback(
    (date: Dayjs | null) => {
      if (date) {
        if (useUtc) {
          const m = moment.utc(date.format('YYYY-MM-DD')).add(12, 'h');
          formControl.setValue(m.unix());
          props.onChange && props.onChange(m.unix());
        } else {
          formControl.setValue(date.endOf('day').unix());
          props.onChange && props.onChange(date.endOf('day').unix());
        }
      }
    },
    [formControl, props, useUtc],
  );

  const isDayBlocked = useCallback(
    (m: moment.Moment) => {
      if (props.minDate) {
        return m.isBefore(toMoment(props.minDate).startOf('day').subtract(1, 'h'));
      }
      if (props.maxDate) {
        return m.isAfter(toMoment(props.minDate).endOf('day').add(1, 'h'));
      }
      return false;
    },
    [props.maxDate, props.minDate],
  );

  const { token } = theme.useToken();

  const wrapperStyle: React.CSSProperties = {
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
    width: 300,
  };

  return (
    <FormGroup className="theme_date-picker">
      {fieldConfig.label && <Label for={formControl.uid}>{fieldConfig.label}</Label>}
      <div style={wrapperStyle}>
        <Calendar
          mode="month"
          fullscreen={false}
          validRange={validRange}
          defaultValue={fieldValue ? (useUtc ? dayjs.utc(fieldValue.format('YYYY-MM-DD')) : dayjs(fieldValue.format('YYYY-MM-DD'))) : undefined}
          onSelect={date => handleChange(date)}
          disabledDate={(date: Dayjs) => {
            if (props.minDate) {
              return toMoment(date.unix()).isBefore(toMoment(props.minDate).startOf('day').subtract(1, 'h'));
            }
            if (props.maxDate) {
              return toMoment(date.unix()).isAfter(toMoment(props.minDate).endOf('day').add(1, 'h'));
            }
            return false;
          }}
        />
      </div>
      {/* <DayPickerRangeController
        {...props.options}
        startDate={fieldValue}
        endDate={fieldValue}
        isDayBlocked={isDayBlocked}
        isOutsideRange={() => false}
        onDatesChange={({ startDate, endDate }) => handleChange(startDate)}
        focusedInput="startDate"
        onFocusChange={() => R.noop()}
        isFocused={formControl.focused}
        disabled={fieldDisabled}
        numberOfMonths={props.numberOfMonths || 1}
        hideKeyboardShortcutsPanel
        initialVisibleMonth={() => fieldValue || toMoment()}
      /> */}
      {!!fieldError && <FormHelperText style={{ color: '#f44336' }}>{fieldError}</FormHelperText>}
    </FormGroup>
  );
}
